import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import {
  ITextValue,
  VolumeCalculationType,
} from "src/Interfaces/ccOrder";

const fixedVolumeLabel = "مقدار ثابت ( تعداد قرارداد)";

export function getCCOrderVolumeCalculationOptions(
  types: ITextValue[] | null | undefined,
): DropdownItem[] {
  return (types || []).map((type) => ({
    id: type.value,
    name:
      type.value === VolumeCalculationType.Static
        ? fixedVolumeLabel
        : type.text,
  }));
}
